import React from 'react'
import {
  Button,
  Form,
  Text,
  Icon,
  CardContainer,
  constants,
  // @ts-ignore no types
} from '@adc/ui-adc'
import { REGISTER_TO_BID } from 'common/statics'
import _cx from 'classnames/bind'
// @ts-ignore no types
import congratulations from '../../../common/images/congratulations.svg'
import investorFirstLook from '../../../common/images/investor-first-look.svg'
// @ts-ignore no types
import cls from './styles.scss'
import { Context, FirstLookFlowData } from './firstLookFlow'
import { formatFullDateWithDay } from '../../utils/formatters'

const { ColorNames } = constants

const cx = _cx.bind(cls)

type CompleteStepProps = {
  context: Context
  data: FirstLookFlowData
}

const CompleteStep = ({ data, context }: CompleteStepProps) => {
  const {
    closeModal,
    handleRegistration,
    size,
    listing,
    isMobile,
    isInvestorSelection,
  } = context

  const iconSize = isMobile ? 240 : 270

  if (isInvestorSelection) {
    return (
      <Form>
        <div className={cx('complete-title-center')}>
          <img height={iconSize} width={iconSize} src={investorFirstLook} />
          <Text
            className={cx(!isMobile ? 'u-mb-3' : 'u-mt-3')}
            size={!isMobile ? 'big' : 'huge'}
            weight={'heavy'}
            elmId='congratulations-header'
          >
            {!isMobile
              ? 'You’re at the top of the waiting list.'
              : 'Thank you for your interest.'}
          </Text>
        </div>
        <div className={cx('center', 'u-mb-3')}>
          <Text className={cx('u-mt-2')}>
            Properties in the First Look Program are only available for purchase
            by investors once the First Look period has expired.
          </Text>
          <CardContainer
            className={cx('expiration-card')}
            dropShadow='small'
            borderRadius='extra-small'
            padding='extra-small'
          >
            <Text
              weight='heavy'
              className={cx('u-mb-1')}
              color={ColorNames.GrayMedium}
            >
              First Look Period Expires:
            </Text>
            <Text weight='heavy' color={ColorNames.Gray}>
              {formatFullDateWithDay(
                listing?.listing_configuration?.first_look_end_date
              )}
            </Text>
          </CardContainer>
          <Text className={cx('u-mt-2')}>
            We will inform you once this property becomes available for
            investors to place bids.
          </Text>
        </div>
      </Form>
    )
  }

  return data.__computed__?.errorResponse ? (
    <Form className={cx('center')}>
      <div
        className={cx('flex-center', 'large-space-bottom', 'large-space-top')}
      >
        <Icon iconStyle='light' name='times-circle' color='error' size='huge' />
      </div>
      <div className={cx('center', 'large-space-bottom')}>
        <Text.Header className={cx('u-mb-3')} level={2}>
          An unexpected error has occurred.
        </Text.Header>
        <Text size='large'>
          We were unable to save your selection. Please try again later.
        </Text>
      </div>
      <div className={cx('complete-center', 'u-mb-1')}>
        <Button
          className={cx('large-fixed-button')}
          role='primary'
          elmId='error_close_button'
          onClick={closeModal}
        >
          Close
        </Button>
      </div>
    </Form>
  ) : (
    <Form>
      <div className={cx('complete-title-center')}>
        <img height={iconSize} width={iconSize} src={congratulations} />
        <Text
          className={cx(!isMobile ? 'u-mb-3' : 'u-mt-3')}
          size={!isMobile ? 'big' : 'huge'}
          weight={'heavy'}
          elmId='congratulations-header'
        >
          Congratulations!
        </Text>
      </div>
      <div className={cx('center', 'u-mb-3')}>
        <Text size='large'>
          You are now qualified to bid on this property during the First Look
          Period.
        </Text>
        <Text size='large'>
          Continue to registration to be ready before the auction date arrives.
        </Text>
      </div>
      <div className={cx('complete-center', 'u-mb-1')}>
        <Button
          role='primary'
          elmId='step3_registration_button'
          className={cx(size === 'large' ? 'large-fixed-button' : '')}
          onClick={handleRegistration}
        >
          {REGISTER_TO_BID}
        </Button>
        <Button
          role='secondary'
          elmId='step3_back_button'
          className={cx(size === 'large' ? 'large-fixed-button' : '')}
          onClick={closeModal}
        >
          Back to Property Details
        </Button>
      </div>
    </Form>
  )
}
export default CompleteStep
